<template lang="pug">
transition(name="dialog" @after-leave="$emit('after-close')")
  .briq-dialog-backdrop(@click.self="$emit('close')")
    .briq-dialog(:class="dialogSize" data-test-id="briq-dialog")
      a.briq-dialog-close(v-if="hideCloseButton" @click="$emit('close')") ✕
      slot
</template>

<script>
export default {
  props: {
    dialogSize: String,
    hideCloseButton: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped lang="stylus">
.briq-dialog-backdrop
  background-color rgba(44, 51, 58, .5)
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  display flex
  align-items center
  justify-content center
  z-index 1130

.briq-dialog
  border-radius 6px
  z-index 10001
  border 1px solid #c1c1c1
  min-width 600px
  padding 32px 32px 32px 32px
  background white
  position relative
  text-align left
  display flex
  flex-flow column nowrap

.briq-dialog-extra-large
  min-width 85%
  min-height 85%
  max-width 85%

.briq-dialog-large
  min-width 70%
  min-height 80%
  max-width 70%

.briq-dialog-medium
  width 33%

.briq-dialog-close
  cursor pointer
  position absolute
  right 17px
  top 17px
  border none
  background transparent

// ===== transitions =====

.dialog-enter, .dialog-leave-to
  opacity 0

  .briq-dialog
    transform translateY(-50px)

.dialog-enter-active, .dialog-leave-active
  transition opacity 0.2s ease

  .briq-dialog
    transition all 0.2s ease
</style>
